module.exports = __webpack_public_path__ + "img/small_whale35.77bf10ee.jpg";